import { render } from "./DragAndDrop.vue?vue&type=template&id=ac98f9b0&scoped=true"
import script from "./DragAndDrop.vue?vue&type=script&lang=js"
export * from "./DragAndDrop.vue?vue&type=script&lang=js"

import "./DragAndDrop.vue?vue&type=style&index=0&id=ac98f9b0&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac98f9b0"]])

export default __exports__